/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import type Mithril from 'mithril';
import editBookshelfAction from '../utils/editBookshelfAction';
import type Bookshelf from '../../common/models/Bookshelf';

export interface CreateBookshelfBtnAttrs extends ComponentAttrs {
	label?: Mithril.Children;
	/** Refreshing the list this button sits in is the caller's job — nothing here does it. */
	onCreated: (bookshelf: Bookshelf) => void;
}

export default class CreateBookshelfBtn<CustomAttrs extends CreateBookshelfBtnAttrs = CreateBookshelfBtnAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { label, onCreated } = this.attrs;

		const _label = label ? label : app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.create_bookshelf_button');

		return (
			<Button
				icon="fas fa-edit"
				className="Button Button--primary IndexPage-newDiscussion"
				itemClassName="App-primaryControl"
				onclick={(e: MouseEvent) => {
					// `BookshelfDropdown` only lets `Button--primary` clicks close its menu (meant for the submit button),
					// and `BookshelvesListItemEmpty` wraps this button in a card that opens the same modal.
					e.stopPropagation();
					editBookshelfAction(null, onCreated);
				}}
			>
				{_label}
			</Button>
		);
	}
}
